@if (timeOut()) {
  <div class="h-full flex align-items-center justify-content-center widget">
    <app-timeout></app-timeout>
  </div>
} @else if (loading()) {
  <div class="h-full flex align-items-center justify-content-center widget">
    <p-progressSpinner class="customProgressSpinner" />
  </div>
} @else {
  @if (!compact()) {
    <!-- Normal non-Compact version: -->
    <ngx-simplebar class="widget h-full">
      <div class="flex p-4 justify-content-between h-full">
        <div class="flex flex-column justify-content-center">
          @if (title()) {
            <span class="kpiTitle"> {{ title() ?? "" | translate }}</span>
          }

          <span class="kpiValue"> {{ source() }}</span>

          @if (label()) {
            <span class="kpiLabel">{{ label() ?? "" | translate }}</span>
          }
        </div>
        @if (iconName()) {
          <app-svg-icon
            style="align-content: center"
            [iconName]="iconName()"
            iconSize="xl"
            [iconColor]="iconColor()"
          ></app-svg-icon>
        }
      </div>
    </ngx-simplebar>
  } @else {
    <!-- Compact version: -->
    <div class="flex flex-column justify-content-center align-items-center p-3">
      @if (iconName()) {
        <app-svg-icon
          [iconName]="iconName()"
          iconSize="m"
          [iconColor]="iconColor()"
          style="align-self: flex-start"
        ></app-svg-icon>
      }
      @if (title()) {
        <span class="kpiTitle"> {{ title() ?? "" | translate }}</span>
      }

      <span class="kpiValue"> {{ source() }}</span>

      @if (label()) {
        <span class="kpiLabel">{{ label() ?? "" | translate }}</span>
      }
    </div>
  }
}
